import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, race } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Dodaj withCredentials do każdego zapytania — ciasteczko httpOnly jest wysyłane automatycznie
    const credReq = req.clone({ withCredentials: true });

    // Dla endpointów auth przepuść bez obsługi błędów 401
    if (
      req.url.endsWith('/auth/login') ||
      req.url.endsWith('/auth/register') ||
      req.url.endsWith('/auth/refresh-token') ||
      req.url.endsWith('/auth/verify-token')
    ) {
      return next.handle(credReq);
    }

    return next.handle(credReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return this.handleAuthError(credReq, next);
        }
        return throwError(() => error);
      })
    );
  }

  private handleAuthError(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authService = this.injector.get(AuthService);

    // Deleguj do authService — jeśli modal jest już otwarty, handleTokenExpiry() nic nie zrobi
    authService.handleTokenExpiry();

    // Czekaj na wynik: odświeżenie tokenu (retry) lub wygaśnięcie sesji (error)
    // req ma już withCredentials: true — retry wyśle ciasteczko
    return race(
      authService.tokenRefreshed$.pipe(
        take(1),
        switchMap(() => next.handle(req))
      ),
      authService.tokenExpired$.pipe(
        take(1),
        switchMap(() => throwError(() => new Error('Session expired')))
      )
    );
  }
}
